export function getConfig() {
  return require(`../../config/${process.env.REACT_APP_CONFIG}`);
}



// WEBPACK FOOTER //
// ./src/utils/config.js